export const SHOW_ERR_MSG = "SHOW_ERR_LOGGED_MSG";
export const SHOW_ON_LOADING = "SHOW_LOADING";
export const HIDE_ON_LOADING = "HIDE_ON_LOADING";
export const SET_ROUTER = "SET_ROUTER";
export const HIDE_MODAL = "HIDE_MODAL";
export const SET_MODAL_RESULT = "SET_MODAL_RESULT";
export const SET_MODAL_DATA_AND_SHOW = "SET_MODAL_DATA_AND_SHOW";
export const HIDE_SNACKBAR = "HIDE_SNACKBAR";
export const SET_SNACKBAR_RESULT = "SET_SNACKBAR_RESULT";
export const SET_SNACKBAR_DATA_AND_SHOW = "SET_SNACKBAR_DATA_AND_SHOW";
export const SET_LEGAL_TEXT = "SET_LEGAL_TEXT";
export const HIDE_COOKIES_WARNING = "HIDE_COOKIES_WARNING";
